import { rest } from 'msw';
import { getEnv } from 'util/getEnv';
import { makeListResults } from 'test-util/api/response';
import { stores } from './fixtures/stores.fixture';
import { items } from './fixtures/items.fixture';
import { groups } from '../ordering-service/fixtures/groups.fixture';
import { allCatalogs, catalogs } from './fixtures/catalogs.fixture';
import { salesReport } from './fixtures/sales.report.fixture';
import { dailySalesReport } from './fixtures/daily-sales-report.fixture';
import { diItems } from './fixtures/di-items.fixture';
import { diGroups } from './fixtures/di-groups.fixture';
import { orderDetails } from './fixtures/order-details.fixture';
import { cachecatalogs } from './fixtures/cache-catalogs.fixture';
export const createStoreOrderingSettingMock = fn =>
  rest.post(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-ordering-service/locations`,
    fn,
  );

export const getStoreOrderingSettingMock = fn =>
  rest.get(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-ordering-service/locations/:locationId`,
    fn,
  );

export const updateStoreOrderingSettingMock = fn =>
  rest.put(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-ordering-service/locations/:locationId`,
    fn,
  );

export const deleteStoreOrderingSettingMock = fn =>
  rest.delete(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-ordering-service/locations/:locationId`,
    fn,
  );

export const sendOrderTransactionReceiptMock = fn =>
  rest.get(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-ordering-service/orders/:orderId/sendreceipt`,
    fn,
  );

export const listItemsMock = fn =>
  rest.get(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-ordering-service/adminitems`,
    fn,
  );

export const postItemsMock = fn =>
  rest.post(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-ordering-service/items/list`,
    fn,
  );

export const listAllCatalogMenusMock = fn =>
  rest.get(
    `${getEnv('REACT_APP_ADMIN_API_URL')}/view/externallocation/catalogs`,
    fn,
  );

export const listGroupsMock = fn =>
  rest.get(
    `${getEnv('REACT_APP_ADMIN_API_URL')}/incentivio-ordering-service/groups`,
    fn,
  );

export const postGroupsMock = fn =>
  rest.post(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-ordering-service/groups/list`,
    fn,
  );

export const listMenusMock = fn =>
  rest.get(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-ordering-service/admincatalogs`,
    fn,
  );

export const postMenusMock = fn =>
  rest.post(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-ordering-service/catalogs/list`,
    fn,
  );

export const publishMenuMock = fn =>
  rest.post(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-ordering-service/cachecatalogs`,
    fn,
  );

export const deleteMenuMock = fn =>
  rest.delete(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-ordering-service/catalogs/:catalogId`,
    fn,
  );

export const deleteMenusMock = fn =>
  rest.post(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-ordering-service/catalogs/delete`,
    fn,
  );

export const getMenuMock = fn =>
  rest.get(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-ordering-service/admincatalogs/:catalogId`,
    fn,
  );

export const createMenuMock = fn =>
  rest.put(
    `${getEnv('REACT_APP_ADMIN_API_URL')}/incentivio-ordering-service/catalogs`,
    fn,
  );

export const getSalesReportMock = fn =>
  rest.get(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-ordering-service/dailyadminorders`,
    fn,
  );

export const dailySalesReportMock = fn =>
  rest.post(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-ordering-service/daily-sales-export`,
    fn,
  );
export const listItemsByDisplayInfoMock = fn =>
  rest.get(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-ordering-service/adminitems/by-displayinfo-title`,
    fn,
  );

export const listGroupsByDisplayInfoMock = fn =>
  rest.get(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-ordering-service/admingroups/by-displayinfo-title`,
    fn,
  );

export const getAdminGroupMock = fn =>
  rest.get(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-ordering-service/admingroups/:groupId`,
    fn,
  );

export const createGroupMock = fn =>
  rest.put(
    `${getEnv('REACT_APP_ADMIN_API_URL')}/incentivio-ordering-service/groups`,
    fn,
  );

export const deleteGroupMock = fn =>
  rest.delete(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-ordering-service/groups/:groupId`,
    fn,
  );

export const deleteGroupsMock = fn =>
  rest.post(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-ordering-service/groups/delete`,
    fn,
  );

export const getOrderDetailsMock = fn =>
  rest.get(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-ordering-service/adminorders/:orderId`,
    fn,
  );

export const refundOrderPaymentMock = fn =>
  rest.post(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-ordering-service/orders/reversepayment`,
    fn,
  );

export const getItemDetailMock = fn =>
  rest.get(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-ordering-service/adminitems/:id`,
    fn,
  );

export const catalogsBulkUpdateMock = fn =>
  rest.patch(
    `${getEnv('REACT_APP_ADMIN_API_URL')}/incentivio-ordering-service/catalogs`,
    fn,
  );

export const groupsBulkUpdateMock = fn =>
  rest.patch(
    `${getEnv('REACT_APP_ADMIN_API_URL')}/incentivio-ordering-service/groups`,
    fn,
  );

export const createItemMock = fn =>
  rest.put(
    `${getEnv('REACT_APP_ADMIN_API_URL')}/incentivio-ordering-service/items`,
    fn,
  );

export const deleteItemMock = fn =>
  rest.delete(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-ordering-service/items/:itemId`,
    fn,
  );

export const deleteItemsMock = fn =>
  rest.post(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-ordering-service/items/delete`,
    fn,
  );

export const itemsBulkUpdateMock = fn =>
  rest.patch(
    `${getEnv('REACT_APP_ADMIN_API_URL')}/incentivio-ordering-service/items`,
    fn,
  );

export const createMerchantSettingsMock = fn =>
  rest.post(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-ordering-service/merchants`,
    fn,
  );

export const getPoolAccountTimezoneMock = fn =>
  rest.get(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-ordering-service/clients/:clientId/poolaccount`,
    fn,
  );

export const handlers = () => [
  createStoreOrderingSettingMock((req, res, ctx) => {
    return res(
      ctx.json({
        locationId: req.body.storeId,
      }),
    );
  }),

  getStoreOrderingSettingMock((req, res, ctx) => {
    const store = stores.find(
      store => store.locationId === req.params.locationId,
    );
    return !!store ? res(ctx.json(store)) : res(ctx.status(404));
  }),

  updateStoreOrderingSettingMock((_req, res, ctx) => {
    return res(ctx.status(200));
  }),

  deleteStoreOrderingSettingMock((_req, res, ctx) => {
    return res(ctx.status(200));
  }),

  sendOrderTransactionReceiptMock((_req, res, ctx) => {
    return res(ctx.status(200));
  }),

  listItemsMock((req, res, ctx) => {
    return res(
      ctx.json(
        makeListResults(items.items, req.url.searchParams, {
          listName: 'items',
        }),
      ),
    );
  }),

  postItemsMock((req, res, ctx) => {
    return res(
      ctx.json(
        makeListResults(items.items, req.url.searchParams, {
          listName: 'items',
        }),
      ),
    );
  }),

  listGroupsMock((req, res, ctx) => {
    return res(
      ctx.json(
        makeListResults(groups.groups, req.url.searchParams, {
          listName: 'groups',
        }),
      ),
    );
  }),

  postGroupsMock((req, res, ctx) => {
    return res(
      ctx.json(
        makeListResults(groups.groups, req.url.searchParams, {
          listName: 'groups',
        }),
      ),
    );
  }),

  listMenusMock((req, res, ctx) => {
    return res(
      ctx.json(
        makeListResults(catalogs.catalogs, req.url.searchParams, {
          listName: 'catalogs',
        }),
      ),
    );
  }),

  postMenusMock((req, res, ctx) => {
    return res(
      ctx.json(
        makeListResults(catalogs.catalogs, req.url.searchParams, {
          listName: 'catalogs',
        }),
      ),
    );
  }),

  listAllCatalogMenusMock((_req, res, ctx) => {
    return res(ctx.json(allCatalogs));
  }),

  publishMenuMock((_req, res, ctx) => {
    return res(ctx.json(cachecatalogs));
  }),

  deleteMenuMock((_req, res, ctx) => {
    return res(ctx.status(200));
  }),

  deleteMenusMock((_req, res, ctx) => {
    return res(ctx.status(200));
  }),

  getMenuMock((req, res, ctx) => {
    const filteredCatalog = catalogs.catalogs.filter(
      catalog => catalog.catalogId === req.params.catalogId,
    )[0];
    return res(ctx.json(filteredCatalog));
  }),

  createMenuMock((_req, res, ctx) => {
    return res(ctx.json({ catalogId: '6674215a03e96232db85b820' }));
  }),

  getSalesReportMock((req, res, ctx) => {
    return res(
      ctx.json({
        ...makeListResults(salesReport.orders, req.url.searchParams, {
          listName: 'orders',
        }),
        totalAmount: salesReport.totalAmount,
        summary: salesReport.summary,
      }),
    );
  }),

  dailySalesReportMock((req, res, ctx) => {
    return res(ctx.json(dailySalesReport));
  }),

  listItemsByDisplayInfoMock((req, res, ctx) => {
    return res(
      ctx.json(
        makeListResults(diItems.items, req.url.searchParams, {
          listName: 'items',
        }),
      ),
    );
  }),

  listGroupsByDisplayInfoMock((req, res, ctx) => {
    return res(
      ctx.json(
        makeListResults(diGroups.groups, req.url.searchParams, {
          listName: 'groups',
        }),
      ),
    );
  }),

  getAdminGroupMock((req, res, ctx) => {
    const filteredGroup = groups.groups.filter(
      group => group.groupId === req.params.groupId,
    )[0];
    return res(ctx.json(filteredGroup));
  }),

  createGroupMock((req, res, ctx) => {
    return res(ctx.json(req.body.groupId));
  }),

  deleteGroupMock((_req, res, ctx) => {
    return res(ctx.status(200));
  }),

  deleteGroupsMock((_req, res, ctx) => {
    return res(ctx.status(200));
  }),

  getOrderDetailsMock((req, res, ctx) => {
    return res(ctx.json(orderDetails));
  }),

  refundOrderPaymentMock((_req, res, ctx) => {
    return res(ctx.status(200));
  }),

  getItemDetailMock((req, res, ctx) => {
    const itemIdReq = req.params.id;
    return res(ctx.json(items.items.find(x => x.itemId === itemIdReq)));
  }),

  catalogsBulkUpdateMock((_req, res, ctx) => {
    return res(ctx.status(200));
  }),

  groupsBulkUpdateMock((_req, res, ctx) => {
    return res(ctx.status(200));
  }),

  createItemMock((req, res, ctx) => {
    return res(ctx.json(req.body.itemId));
  }),

  deleteItemMock((_req, res, ctx) => {
    return res(ctx.status(200));
  }),

  deleteItemsMock((_req, res, ctx) => {
    return res(ctx.status(200));
  }),

  itemsBulkUpdateMock((_req, res, ctx) => {
    return res(ctx.status(200));
  }),

  createMerchantSettingsMock((_req, res, ctx) => {
    return res(ctx.json({ merchantId: 'merchantId' }));
  }),

  getPoolAccountTimezoneMock((_req, res, ctx) => {
    return res(ctx.body('Africa/Nairobi'));
  }),
];
